import { CookiesBannerComponent, FooterComponent } from '@myre/ui-domain-core';
import { DynamicEnvService } from '@myre/ui-domain-http';
import { ModalWrapperComponent } from '@myre/ui-primitive-modal';

import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthService } from './guards/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CookiesBannerComponent,
    FooterComponent,
    ModalWrapperComponent,
    RouterOutlet,
  ],
})
export class AppComponent {
  protected readonly _dynamicEnvService = inject(DynamicEnvService);
  protected readonly _authService = inject(AuthService);
}
